import { FC, useContext, useEffect, useMemo } from 'react';
import { createGQLDataContext } from 'utils/createDataContext';
import { useGQLQuery } from 'hooks';
import { B2bPositionsSettingsPageFetchPositionsByDepartmentIdQuery } from 'types/graphql';
import { GQLAPIContextType } from 'types/common.types';
import { useLocation } from 'react-router-dom';
import { UseGQLQuery, UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { fetchPositionsByDepartmentIdQueryConfig } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.constants';
import { IPositionsByDepartmentId } from 'pages/Settings/pages/Positions/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.types';

export const PositionsAllocationModalDataContext = createGQLDataContext<
  UseGQLQuery<IPositionsByDepartmentId>
>({} as UseGQLQuery<IPositionsByDepartmentId>);

export const PositionsAllocationModalDataProvider: FC = ({ children }) => {
  const { pathname } = useLocation();
  const departmentId = Number.parseInt(pathname.split('/')[3], 10);

  const queryConfig = useMemo<
    UseGQLQueryConfig<
      B2bPositionsSettingsPageFetchPositionsByDepartmentIdQuery,
      IPositionsByDepartmentId,
      {}
    >
  >(() => fetchPositionsByDepartmentIdQueryConfig(departmentId), [departmentId]);

  const { fetch, ...rest } =
    useGQLQuery<
      B2bPositionsSettingsPageFetchPositionsByDepartmentIdQuery,
      IPositionsByDepartmentId,
      {}
    >(queryConfig);
  useEffect(() => {
    fetch();
  }, [departmentId, fetch]);

  return (
    <PositionsAllocationModalDataContext.Provider value={rest}>
      {children}
    </PositionsAllocationModalDataContext.Provider>
  );
};

export const usePositionsAllocationModalDataContext =
  (): GQLAPIContextType<IPositionsByDepartmentId> =>
    useContext(PositionsAllocationModalDataContext);
